import _ from 'lodash';

export default (phoneNumbers, number, tags) => {
	const numbers = _.cloneDeep(phoneNumbers || []);
	const index = _.findIndex(numbers, phone => _.intersection(phone.tags, tags).length);

	if (index === -1) {
		numbers.push({
			tags,
			number
		});
	} else {
		numbers[index] = {
			tags: _.uniq(numbers[index].tags.concat(tags)),
			number
		};
	}

	return numbers;
};
